import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// React Form.Check elements have default styling and don't allow changing colors. We already addressed this so we will use this custom form check with custom classes
const CustomFormCheck = React.forwardRef((props,ref) => {
  let inputElement;
  if (props.dynamic) {
    let checked = props.checked ? props.checked : false;
    const [isChecked, setIsChecked] = useState(checked);
    const handleChange = props.onChange
      ? () => {
          props.onChange();
          setIsChecked(!isChecked);
        }
      : () => {
          setIsChecked(!isChecked);
        };
    inputElement = (
      <>
        {props.sendUncheckedValue && props.name && !isChecked && <input name={props.name} value="0" hidden readOnly />}
        <input
          id={props.id ? props.id : undefined}
          disabled={props.disabled ? props.disabled : false}
          className={"custom-control-input"}
          type="checkbox"
          checked={isChecked}
          name={props.name ? props.name : undefined}
          onChange={handleChange}
          style={{ zIndex: "1" }}
          required={props.required}
          value="1"
          ref={ref}
        />
      </>
    );
  } else if (props.static && window.location.href.includes("ppc-config?page=ppc&subpage=ids_data") && props.label == "Pull Shopify data on save") {
    inputElement = (
      <>
        {props.sendUncheckedValue && props.name && <input name={props.name} value="0" hidden readOnly />}
        {<input name="[pull_platform_data][ppc][manual_pull_shopify]" value={true} hidden readOnly />}
        <input
          id={props.id ? props.id : undefined}
          disabled={props.disabled ? props.disabled : false}
          className={"custom-control-input"}
          type="checkbox"
          defaultChecked={props.defaultChecked ? props.defaultChecked : false}
          name={props.name ? props.name : undefined}
          value="1"
          style={{ zIndex: "1" }}
          required={props.required}
          onChange={props.onChange}
        />
      </>
    );
  } else if (props.static) {
    inputElement = (
      <>
        {props.sendUncheckedValue && props.name && <input name={props.name} value="0" hidden readOnly />}
        <input
          id={props.id ? props.id : undefined}
          disabled={props.disabled ? props.disabled : false}
          className={"custom-control-input"}
          type="checkbox"
          defaultChecked={props.defaultChecked ? props.defaultChecked : false}
          name={props.name ? props.name : undefined}
          value="1"
          style={{ zIndex: "1" }}
          required={props.required}
          onChange={props.onChange}
        />
      </>
    );
  } else {
    inputElement = (
      <>
        {props.sendUncheckedValue && props.name && !props.checked && <input name={props.name} value="0" hidden readOnly />}
        <input
          id={props.id ? props.id : undefined}
          disabled={props.disabled ? props.disabled : false}
          className="custom-control-input"
          type="checkbox"
          checked={props.checked ? props.checked : false}
          name={props.name ? props.name : undefined}
          onChange={
            props.onChange
              ? props.onChange
              : () => {
                  false;
                }
          }
          value="1"
          style={{ zIndex: "1" }}
          required={props.required}
          readOnly={props.readOnly}
        />
      </>
    );
  }

  return (
    <>
      <div className={props.goalConfig ? "custom-control control-fix custom-checkbox" : "custom-control custom-checkbox"}>
        {inputElement}
        {props.hoverText ? (
          <OverlayTrigger
            placement={"top"}
            overlay={
              <Tooltip className="grow-tooltip" id="button-tooltip">
                <div className="primary">{props.hoverText}</div>
              </Tooltip>
            }>
            <label
              className="custom-control-label primary"
              htmlFor={props.id ? props.id : undefined}
              style={{ cursor: props.disabled ? "default" : "pointer" }}
              dangerouslySetInnerHTML={{
                __html: props.label ? props.label : undefined,
              }}></label>
          </OverlayTrigger>
        ) : (
          <label
            className="custom-control-label primary"
            htmlFor={props.id ? props.id : undefined}
            style={{ cursor: props.disabled ? "default" : "pointer" }}
            dangerouslySetInnerHTML={{
              __html: props.label ? props.label : undefined,
            }}></label>
        )}
      </div>
    </>
  );
})
export default CustomFormCheck